import React, {useCallback, useState} from 'react';
import images from "../../assets/tattoo/tattoo"
import "./gallery.css"
import Gallery from "react-photo-gallery";
import Carousel, {Modal, ModalGateway} from "react-images";

const TattooGallery = () => {
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = useCallback((event, { photo, index }) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    }, []);

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    return <div className="gallery">
        <Gallery photos={images} onClick={openLightbox}/>
        <ModalGateway>
            {viewerIsOpen ? (
                <Modal onClose={closeLightbox}>
                    <Carousel
                        currentIndex={currentImage}
                        views={images.map(x => ({
                            ...x,
                            srcset: x.srcSet,
                            caption: x.title
                        }))}
                    />
                </Modal>
            ) : null}
        </ModalGateway>
    </div>
}

export default TattooGallery;